import { render, staticRenderFns } from "./IncreaseNumber.vue?vue&type=template&id=52b4a28c&"
import script from "./IncreaseNumber.vue?vue&type=script&lang=js&"
export * from "./IncreaseNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52b4a28c')) {
      api.createRecord('52b4a28c', component.options)
    } else {
      api.reload('52b4a28c', component.options)
    }
    module.hot.accept("./IncreaseNumber.vue?vue&type=template&id=52b4a28c&", function () {
      api.rerender('52b4a28c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2HhNIENO9CX6e/JS/comp/IncreaseNumber.vue"
export default component.exports